import "../../styles/Offerings/OfferingPlan.css";

const OfferringPlan = () => {
  const pricingData = [
    { label: "Price", values: ["₹50/K MONTH", "₹1/L MONTH", "₹1.5/L MONTH"] },
    {
      label: "Startup Evaluation (₹10K Value)",
      values: ["Free", "Free", "Free"],
      highlight: true,
    },
    {
      label: "Ready-To-Launch Templates",
      values: ["Included", "Included", "Included"],
    },
    {
      label: "1:1 Consulting Support (Up To 10 Hrs/Month)",
      values: ["✅", "✅", "✅"],
      right: [0, 1, 2],
    },
    {
      label: "Mentoring Support",
      values: ["❌", "Included", "Included"],
      cross: [0],
    },
    {
      label: "Scaling & Growth Hacking Support",
      values: ["❌", "❌", "Included"],
      cross: [0, 1],
    },
    {
      label: "Ideal For",
      values: [
        "Idea Validation & MVP Planning",
        "Overcoming Early Challenges",
        "Scaling & Growth",
      ],
    },
  ];

  const links = [
    { stage: "Idea Stage", url: "/idea-stage" },
    { stage: "Valley Stage", url: "/valley-stage" },
    { stage: "Growth Stage", url: "/growth-stage" },
  ];

  return (
    <div className="offering-plan-container">
      <div className="offering-plan-innercontainer">
        <div>
          <div className="offering-plan-title">Choose Your Plan</div>
          <div className="offering-plan-desc">
            Compare Our Offerings & Select What Works Best for You
          </div>
        </div>
        <div className="pricing-table-container">
          <table className="pricing-table">
            <thead>
              <tr>
                <th className="first-column">Stage</th>
                {links.map((link) => (
                  <th key={link.stage}>{link.stage}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pricingData.map((row, index) => (
                <tr key={index}>
                  <td className="first-column">{row.label}</td>
                  {row.values.map((value, i) => (
                    <td
                      key={i}
                      className={row.highlight ? "highlight" : ""}
                    >
                      {value === "✅" ? (
                        <img src="/check.svg" alt="Check" className="icon" />
                      ) : value === "❌" ? (
                        <img src="/remove.svg" alt="Remove" className="icon" />
                      ) : (
                        value
                      )}
                    </td>
                  ))}
                </tr>
              ))}
              <tr>
                <td className="first-column">Know More</td>
                {links.map((link, index) => (
                  <td key={index}>
                    <a href={link.url}>{link.stage} &gt;</a>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OfferringPlan;
